import React, { useState } from "react";
import Card from "./CardAbout";
import Modal from "./Modal";




const About = ({ data }) => {

    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleOpenModal = () => {
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    return (
        <div id="about-us" className="h-fit w-full xs:p-5 p-2.5 flex flex-col justify-between font-manrope leading-tight font-[500] overflow-hidden">
            <div className="h-fit w-full xs:p-4 relative flex xs:flex-row justify-between flex-col-reverse ">
                <div className="flex flex-col lg:w-[45%] xs:w-[40%]">
                    <div className="xs:block hidden">
                        <div className="flex flex-row gap-4 justify-between w-full mt-[15%] mb-[50%]">
                            <div className="flex flex-col">
                                <span style={{ color: `${data.top_block.number_color}` }} className={`lg:text-[80px] xs:text-[56px] text-[48px]`}>{data.top_block.number1}</span>
                                <span style={{ color: `${data.top_block.description_color}` }} className={`text-[14px]`}>{data.top_block.description1}</span>
                            </div>
                            <div className="flex flex-col">
                                <span style={{ color: `${data.top_block.number_color}` }} className={`lg:text-[80px] xs:text-[56px] text-[48px]`}>{data.top_block.number2}</span>
                                <span style={{ color: `${data.top_block.description_color}` }} className={`text-[14px]`}>{data.top_block.description2}</span>
                            </div>
                            <div className="flex flex-col">
                                <span style={{ color: `${data.top_block.number_color}` }} className={`lg:text-[80px] xs:text-[56px] text-[48px]`}>{data.top_block.number3}</span>
                                <span style={{ color: `${data.top_block.description_color}` }} className={`text-[14px]`}>{data.top_block.description3}</span>
                            </div>
                        </div>
                    </div>
                    <div className="xs:hidden block">
                        <div className="flex flex-col gap-4 justify-between w-full mt-[25%]">
                            <div className="flex flex-col ml-auto mr-[10%]">
                                <span style={{ color: `${data.top_block.number_color}` }} className={`lg:text-[80px] xs:text-[56px] text-[48px]`}>{data.top_block.number3}</span>
                                <span style={{ color: `${data.top_block.description_color}` }} className={`text-[14px]`}>{data.top_block.description3}</span>
                            </div>

                            <div className="flex flex-col ml-[30%] mb-[25%] mt-[20%]">
                                <span style={{ color: `${data.top_block.number_color}` }} className={`lg:text-[80px] xs:text-[56px] text-[48px]`}>{data.top_block.number1}</span>
                                <span style={{ color: `${data.top_block.description_color}` }} className={`text-[14px]`}>{data.top_block.description1}</span>
                            </div>
                            <div className="flex flex-col ml-auto mr-[10%] w-[40%]">
                                <span style={{ color: `${data.top_block.number_color}` }} className={`lg:text-[80px] xs:text-[56px] text-[48px]`}>{data.top_block.number2}</span>
                                <span style={{ color: `${data.top_block.description_color}` }} className={`text-[14px]`}>{data.top_block.description2}</span>
                            </div>
                        </div>
                    </div>

                    <div style={{ backgroundColor: `${data.top_block.vidget_bg}` }} className={`flex xs:flex-row flex-col xs:gap-2 relative items-center lg:min-w-[313px] xs:w-[270px] w-[152px] justify-between xs:h-[86px] h-[123px] rounded-2xl border-[${data.top_block.border_color}] border-[1px] py-3 px-[15px]`}>
                        <div className="flex flex-row xs:w-fit w-full">
                            <span className="xs:text-[56px] text-[40px]">
                                {data.top_block.vidget_score}
                            </span>
                            <img src={data.top_block.arrow_vidget} alt="Arrow" className="xs:hidden block h-6 w-6 ml-auto mb-auto" />
                        </div>
                        <div className="flex flex-col gap-2 h-full">
                            <img src={data.top_block.stars} alt="Stars" className="xs:h-[24px] xs:w-[128px] w-[108px] h-[20px]" />
                            <span className="text-[14px] text-nowrap">
                                {data.top_block.vidget_reviews}
                            </span>
                        </div>
                        <img src={data.top_block.arrow_vidget} alt="Arrow" className="xs:block hidden h-6 w-6 ml-auto mb-auto" />
                    </div>
                </div>

                <div className="flex flex-col gap-3 h-full lg:w-[50%] xs:w-[55%]">
                    <div className="justify-between flex flex-col h-fit">
                        <span className="lg:text-[40px] xs:text-[32px] text-[28px] xs:mb-8 mb-5">{data.top_block.title}</span>
                        <span className="lg:text-[20px] xs:text-[16px] xs:mb-8 mb-5">{data.top_block.description_right1}</span>
                        <span className="lg:text-[20px] xs:text-[16px] xs:mb-16 mb-4">{data.top_block.description_right2}</span>
                    </div>
                    <div className="flex lg:flex-row flex-col gap-3">
                        <a href="#offices">
                            <div>
                                <button
                                    className={`xs:w-[291px] w-[241px] xs:h-[48px] h-[44px] whitespace-nowrap group mb-auto transition duration-300 bg-[#C3372E] xs:bg-[#1F2225] text-white hover:bg-[#E0473F] hover:text-[#FFF] rounded-full px-5 py-2.5 xs:text-[20px] text-[16px] flex items-center justify-between gap-2
                                active:bg-[#C3372E]`}>
                                    <span className="">{data.top_block.left_button_text}</span>
                                    <img src={data.top_block.arrow} alt="Arrow" className="invert" />
                                </button>
                            </div>
                        </a>
                        <div className="xs:block hidden">
                            <button
                                onClick={handleOpenModal}
                                className={`w-[229px] h-[48px] whitespace-nowrap group mb-auto transition duration-300 bg-[${data.top_block.right_button_bg}] text-[${data.top_block.right_button_text_color}] hover:bg-[#353A40] hover:text-[#FFF] border-[#1F2225] border-[1px] rounded-full px-5 py-2.5 xs:text-[20px] text-[16px] flex items-center justify-between gap-2
                            active:bg-[#1F2225]`}>
                                <span className="">{data.top_block.right_button_text}</span>
                                <img src={data.top_block.arrow} alt="Arrow" className="transition duration-300 group-hover:invert" />
                            </button>
                        </div>
                    </div>
                </div>
                <div style={{ backgroundImage: `url(${data.top_block.map_img})` }} className="lg:w-[1050px] lg:h-[850px] xs:w-[800px] xs:h-[700px] w-[700px] h-[600px] -left-40 xs:-top-16 top-[360px] absolute bg-cover -z-10 bg-no-repeat xs:rotate-[0deg] rotate-[18deg]">
                </div>
            </div>
            <div className="w-full h-fit mt-[10%]">
                <span className={`text-[28px] xs:text-[36px] lg:text-[40px]`}>{data.bot_block.title}</span>
                <div className="mt-8 lg:mt-12 w-full grid grid-cols-1 xs:grid-cols-3 xs:auto-rows-fr gap-4">
                    {data.bot_block.card_list.map((card, index) => (
                        <Card
                            key={index}
                            title={card.title}
                            description={card.description}
                            image={card.image}
                            bg_color={card.bg_color}
                            title_color={card.title_color}
                            description_color={card.description_color}
                        />
                    ))}
                </div>

            </div>
            <Modal isOpen={isModalOpen} onClose={handleCloseModal} />

        </div>

    );
};

export default About;